import styled from "styled-components"

const NavItem = styled.li`
  &:active {
    &>div: after {
      border-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }

  &:hover {
    &>div: after {
      border-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
  & > div:first-of-type a,
  & > div:first-of-type span {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
  @media (max-width: 899px) {
    & > div:first-of-type a,
    & > div:first-of-type span {
      color: ${(props) => props.theme.a_color_gradients.a_light};
    }
    background-color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const SubItemContainer = styled.div`
  & > a {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 899px) {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`
const SubItem = styled.span`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const SubNavItemTitle = styled.li`
  & > a {
    border-bottom: 1px solid
      ${(props) => props.theme.c_color_gradients.c_medium};
  }
`
const MainNav = styled.nav`
  @media (max-width: 899px) {
    border-top: 4px solid ${(props) => props.theme.b_color_gradients.b_dark};
    & > ul {
      &>li: hover, &>li:focus-within { {
        background-color: ${(props) => props.theme.b_color_gradients.b_dark};
      }
      & > li {
        border-bottom: 2px solid
          ${(props) => props.theme.a_color_gradients.a_light};
      }
    }
  }
`

export { NavItem, SubItemContainer, SubItem, SubNavItemTitle, MainNav }
